import { toastr } from 'react-redux-toastr';
import { makeApiCall } from '../../../../../services/apiService/apiService';
import { DamageCnDashboardFailureMessages } from '../damageCnUnblockAndRtoDashboardConstants';
import {
  addCellPrefixAction,
  getBaseFailureObject,
  getBasePendingApiObject,
  getBaseSuccessfulObject,
  loadingMessages
} from '../../../shopFloorManagement/masterData/masterDataRedux/masterDataActionCreator';
import { RTOCNMessages, UnblockCNMessages } from '../../../../helper/Constants';

export const damageCnUnblockAndRtoDashboardActions = {
  GET_DASHBOARD_DATA: 'GET_CN_DASHBOARD_DATA',
  FILTER_DASHBOARD_DATA: 'FILTER_DAMAGE_CN_UNBLOCK_RTO_DASHBOARD_DATA'
};
export const getDashboardDataAction = (load: Object) => ({
  type: damageCnUnblockAndRtoDashboardActions.GET_DASHBOARD_DATA,
  payload: load
});

export const filterDashboardData = (load: Object) => ({
  type: damageCnUnblockAndRtoDashboardActions.FILTER_DASHBOARD_DATA,
  payload: load
});

function GetDashboardFailurePayload(dispatch, res) {
  let errorMessage = 'Unknown error occurred'; // Default error message

  if (res && res.errorMessage) {
    errorMessage = res.errorMessage;
  } else if (res && res.message) {
    // Sometimes the error message might be in a different field, e.g., 'message'
    errorMessage = res.message;
  }
  dispatch(
    getDashboardDataAction({
      isLoading: false,
      isLoaded: true,
      dashboardData: [],
      dashboardDataFiltered: [],
      error: errorMessage
    })
  );
}

const filteredData = val => {
  if (typeof val !== 'string') {
    // Return an empty array or handle the case when `val` is not a string
    return [];
  }
  return val.split(',').filter((value, index, self) => {
    return self.indexOf(value) === index && value !== '';
  });
};

function UnblockCNFailurePayload(dispatch, res) {
  dispatch(
    addCellPrefixAction(
      getBaseFailureObject(res, UnblockCNMessages.FAIL_UNBLOCK, {
        cellData: null
      })
    )
  );
}

function RTOCNFailurePayload(dispatch, res) {
  dispatch(
    addCellPrefixAction(
      getBaseFailureObject(res, RTOCNMessages.RTO_FAIL, {
        cellData: null
      })
    )
  );
}

export const getDashboardData = obj => (dispatch: Function) => {
  dispatch(
    getDashboardDataAction({
      isLoading: true,
      isLoaded: false,
      dashboardData: [],
      dashboardDataFiltered: [],
      error: null
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getBlockedCnList',
    method: 'POST',
    data: [138],
    replaceParamsArr: [
      { key: 'fromDateTime', val: obj.startDate },
      { key: 'toDateTime', val: obj.endDate },
      { key: 'includeInactive', val: true },
      { key: 'removeDelivered', val: true },
      { key: 'showSamSpecificBlockers', val: true }
    ],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getDashboardDataAction({
            isLoading: false,
            isLoaded: true,
            dashboardData: res.payload,
            dashboardDataFiltered: res.payload,
            error: null
          })
        );
      } else if (res.status === 'FAILURE') {
        dispatch(
          getDashboardDataAction({
            isLoading: false,
            isLoaded: true,
            dashboardData: [],
            dashboardDataFiltered: [],
            error:
              res.errorMessage || DamageCnDashboardFailureMessages.GET_CN_FAIL
          })
        );
      }
    },
    failureCb: res => {
      GetDashboardFailurePayload(dispatch, res);
    },
    catchCb: res => {
      GetDashboardFailurePayload(dispatch, res);
    }
  };

  return makeApiCall(requestObj);
};

export const unblockDamagePilferageCns = (
  requestParams: Object,
  cb: Function = () => {}
) => (dispatch: Function) => {
  dispatch(
    addCellPrefixAction(
      getBasePendingApiObject(
        { cellData: null },
        loadingMessages.CREATE_UPDATE_CELL_PREFIX
      )
    )
  );
  const requestObj = {
    apiEndPoint: 'unblockCn',
    baseUrl: 'zoomApiUrl',
    method: 'POST',
    data: {
      cnotes: [requestParams.cnote],
      reasonId: 138
    },
    successCb: res => {
      if (res.status === 'SUCCESS') {
        cb();
        const responseDetails = res.payload || [];
        const unblockDetails = {
          successCN: [],
          invalidCN: [],
          reasonMismatchCN: []
        };

        responseDetails.map(cnDetail => {
          if (cnDetail.message === 'SUCCESS') {
            unblockDetails.successCN.push(cnDetail.cnote);
          } else if (
            cnDetail.message === 'CN_BLOCKER_NOT_FOUND_FOR_GIVEN_REASON'
          ) {
            unblockDetails.reasonMismatchCN.push(cnDetail.cnote);
          } else {
            unblockDetails.invalidCN.push(cnDetail.cnote);
          }
        });

        let successMessage = '';
        if (unblockDetails.successCN.length > 0) {
          successMessage += `${unblockDetails.successCN.length}/${responseDetails.length} ${UnblockCNMessages.SUCCESS}`;
        }
        if (unblockDetails.reasonMismatchCN.length > 0) {
          successMessage += successMessage !== '' ? ' and ' : '';
          successMessage += `${unblockDetails.reasonMismatchCN.length}/${responseDetails.length} ${UnblockCNMessages.CN_BLOCKER_NOT_FOUND_FOR_GIVEN_REASON}`;
        }
        dispatch(
          addCellPrefixAction(
            getBaseSuccessfulObject({ cellData: null }, successMessage)
          )
        );
        if (unblockDetails.invalidCN.length > 0) {
          toastr.error(
            'Error',
            `${unblockDetails.invalidCN.join(', ')} ${
              UnblockCNMessages.INVALID_CNOTE
            }`
          );
        }
      }
    },
    failureCb: res => {
      UnblockCNFailurePayload(dispatch, res);
    },
    catchCb: res => {
      UnblockCNFailurePayload(dispatch, res);
    }
  };
  return makeApiCall(requestObj);
};

export const rtoDamagePilferageCns = (
  requestObject: Object,
  cb: Function = () => {}
) => (dispatch: Function) => {
  dispatch(
    addCellPrefixAction(
      getBasePendingApiObject(
        { cellData: null },
        loadingMessages.CREATE_UPDATE_CELL_PREFIX
      )
    )
  );
  const requestObj = {
    apiEndPoint: 'rtoDamageCn',
    baseUrl: 'zoomApiUrl',
    method: 'POST',
    pathVariables: [{ key: '{cnote}', val: requestObject.cnote }],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        let message = '';
        cb();
        if (res.payload === '') {
          message = 'Something went wrong';
        } else {
          message = `${requestObject.cnote} is successfully marked RTO. Return consignment ${res.payload} created.`;
        }
        dispatch(
          addCellPrefixAction(
            getBaseSuccessfulObject({ cellData: null }, message)
          )
        );
      }
    },
    failureCb: res => {
      RTOCNFailurePayload(dispatch, res);
    },
    catchCb: res => {
      RTOCNFailurePayload(dispatch, res);
    }
  };
  return makeApiCall(requestObj);
};
